import { isEqual } from "lodash-es";
import { computed } from "vue";
import { useStore } from "vuex";
import { getSurveyItemType } from "../constants/SurveyItemType.js";
const SurveyItemMixin = {
  setup() {
    const store = useStore("banza-survey");
    return {
      survey: computed(() => store.state.editor.survey),
      surveyItem: computed(() => store.getters["editor/surveyItem"]),
      surveyItemNumberById: computed(
        () => store.getters["editor/surveyItemNumberById"]
      ),
      changeSurveyItem: (payload) => store.dispatch("editor/changeSurveyItem", payload)
    };
  },
  props: {
    id: String
  },
  data: () => ({
    item: {}
  }),
  computed: {
    settings: {
      get() {
        return this.surveyItem(this.id);
      }
    },
    number() {
      return this.surveyItemNumberById(this.id);
    },
    itemType() {
      return getSurveyItemType(this.item.type);
    },
    isWrapper() {
      var _a;
      return (_a = this.itemType) == null ? void 0 : _a.isWrapper;
    }
  },
  watch: {
    item: {
      handler(val) {
        if (isEqual(val, this.settings)) {
          return;
        }
        this.changeSurveyItem(val);
      },
      deep: true
    },
    settings: {
      handler(val) {
        if (isEqual(val, this.item)) {
          return;
        }
        this.item = { ...val };
      },
      deep: true,
      immediate: true
    }
  }
};
export {
  SurveyItemMixin as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
